import axios from 'axios';

export default class RemoteApiService{
    constructor( api_url, remote_id, remote_token ){
       if(!api_url)
			return false;

		let axios_config = {
			baseURL: api_url,
			timeout: api_url,
			headers: {},
		}


		console.log('RemoteApiService', remote_token, remote_id );

		if(remote_token && remote_id){
			var encoded_token = btoa(remote_id + '|' + remote_token);
			
			axios_config.headers['X-Communiti-Remote-Token'] = encoded_token;
		}
			

        this.client =  axios.create(axios_config); 
        
    }
}